import { Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { ColorHelper, StatusHelper, TableHelper } from "helpers";
import { usePaginationRequest } from "hooks";
import { IGetPeriodCycleCountDetailRequest } from "model";
import { ECCPLocationStatus } from "model/Type/ECCPLocationStatus";
import { useState } from "react";
import { LoadingOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { CycleCountApiService } from "services";
import { CURRENT_PAGE_SIZE, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

interface IProductListProps {
  id: string;
}
const LocationList = (props: IProductListProps) => {
  const action = useAppSelector(
    (state) => state.LoadingOrderReducer.pallet.action
  );

  const [refresh, setRefresh] = useState(false);

  const [request, setRequest] = useState<IGetPeriodCycleCountDetailRequest>({
    documentNbr: "",
    cycleCountPeriodID: props.id,
    pageNumber: FIRST_PAGE,
    pageSize: CURRENT_PAGE_SIZE,
  });

  const { loading, result } = usePaginationRequest<
    IGetPeriodCycleCountDetailRequest,
    any[]
  >(
    request,
    CycleCountApiService.getPeriodicCycleCountDetail,
    [],
    {
      refresh: refresh,
    },
    () => {
      setRefresh(false);
    }
  );

  const _handleChangePage = (pageNumber: number) => {
    setRequest({
      ...request,
      pageNumber,
    });
  };

  const _handleSearch = (searchText: string) => {
    setRequest({
      ...request,
      searchText,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "status",
      headerName: I18nTranslator(translations.masterData.status),
      size: "small",
      align: "left",
      renderCell: ({ value }) => {
        return (
          <Typography
            style={{
              backgroundColor: ColorHelper.getCCPLocationStatusColor(
                value as ECCPLocationStatus
              ),
              padding: "6px 16px",
              borderRadius: "5px",
              color: "white",
              fontWeight: 500,
            }}
          >
            {StatusHelper.getCCPLocationStatusString(value)}
          </Typography>
        );
      },
    }),
    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.masterData.zoneName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.masterData.locationName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.productLot),
      size: "small",
      align: "left",
    }),

    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.masterData.productCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productDescription",
      headerName: I18nTranslator(translations.receive.productName),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.receive.quantity),
      size: "small",
      align: "right",
    }),
  ];
  return (
    <AppTable<any>
      loading={loading}
      data={result}
      columns={COLUMNS}
      hideAddNew
      onSearch={_handleSearch}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchLoadingOrderPallet
      )}
      removeActionColumn
      hideHeader
      defaultHeaderTable={230}
      onChangePage={_handleChangePage}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default LocationList;
